<template>
    <div class="report-summary-wrapper">
        <!-- Loading overlay -->
        <div v-if="isLoading || isDownloading" class="loading-overlay">
            <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
        </div>

        <title-header>
			<v-layout row wrap justify-space-between aling-center>
				<p class="title-header">Evaluado: <span class="date-header">{{ selectedEmployee.fullName }} ( {{ selectedEmployee.job ? selectedEmployee.job.name : '' }} )</span></p>
				<p class="title-header">Fecha de Evaluación: <span class="date-header">{{ startDate }} - {{ endDate }}</span></p>
			</v-layout>
            <v-layout row wrap justify-end align-center>
					<div class="wrapper-btns tw-mr-2">
						<download-btn
							alt="Descargar reporte en PDF"
							:height="27"
							:disabled="!canExportReport"
							url-image="/static/img/icons/pdf.svg"
							@download-item="downloadReport('pdf')"
						></download-btn>
					</div>
					<div class="wrapper-btns tw-mr-10">
						<app-tooltip-button
							text="Enviar reporte a E-mail"
							img="/static/img/mail.svg"
							:disabled="!canExportReport"
							@click-icon="sendEmail"
						></app-tooltip-button>
					</div>
					<div class="wrapper-btns">
						<v-btn color="primary btn-action" @click="goToBack">
							<img
								src="/static/img/icons/btn-right-arrow.webp"
								alt="Atrás"
								class="mr-4"
							/>
							Atrás
						</v-btn>
					</div>
				</v-layout>
        </title-header>
		<div class="methodology">
			<table>
				<tr >
					<td class="meth">METODOLOGÍA:</td>
					<td class="parraf">{{ process.methodology }}</td>
				</tr>
			</table>
		</div>
		<section class="columns-competencies" v-if="!isLoading && competences.length > 0">
			<div>
				<p class="title-box">Competencias Exploradas:</p>
				<div class="line"></div>
				<div class="box">
					<template>
						<ol>
							<li v-for="(competence, index) in competences" :key="index">
								{{ competence.competenceName }}
							</li>
						</ol>
					</template>
				</div>
			</div>
			<div>
				<p class="title-box">Grupos de Evaluación:</p>
				<div class="line"></div>
				<div class="box">
					<ul>
						<li v-for="(role, index) in roles" :key="index">
							{{ role.name }} ({{ role.abbreviation }})
						</li>
					</ul>
				</div>

			</div>
			<div>
				<p class="title-box">Alternativas de Evaluación:</p>
				<div class="line"></div>
				<div class="box">
					<table class="table-evaluation">
						<tr>
							<th>Descripción:</th>
							<th>Valor:</th>
						</tr>
						<tr v-for="(scale, index) in scales" :key="index">
							<td style="font-size: smaller;">{{ scale.name }}</td>
							<td style="font-size: smaller;">{{ scale.value }}</td>
						</tr>
					</table>
				</div>

			</div>
		</section>
		<section class="global-results" v-if="!isLoading && scales.length > 0">
			<p class="results">RESULTADOS GLOBALES</p>
			<div class="connt-info">
				<p>A continuación se muestra los resultados de las competencias genéricas exploradas, comparando el promedio de puntuación de todos los grupos de referencia.</p>
			</div>
			<section class="results-tables-container"
    			:class="{'has-kpis' : kpis}">
				<div>
					<p class="title-box">Puntuaciones Totales{{ kpis ? ' y Resúmen KPI' : '' }}:</p>
					<div class="line"></div>
					<div class="box">
						<div class="tables-container" :class="{ 'has-kpis': kpis }">
							<div class="table-section">
								<p class="table-subtitle">Escalas de Evaluación</p>
								<table class="table-evaluation">
									<tr>
										<th>Descripción:</th>
										<th>Puntuación:</th>
									</tr>
									<tr v-for="(scale, index) in scales" :key="index">
										<td style="font-size: smaller; text-align: start;">
											<div class="scale-entry">
												<div class="scale-badge">{{ scale.value }}</div>
												<div class="scale-label">{{ scale.name }}</div>
											</div>
										</td>
										<td style="font-size: smaller;">
											<div class="score-display">
												<button v-if="scale.point" class="character-abbreviation">T</button>
												<span class="point-value">{{ scale.pointValue }}</span>
											</div>
										</td>
									</tr>
								</table>
							</div>
							<div v-if="kpis" class="table-section">
								<p class="table-subtitle">Resumen KPI</p>
								<table class="table-evaluation kpi-table">
									<tr>
										<th>Descripción:</th>
										<th>Puntuación:</th>
									</tr>
									<tr v-for="(kpi, index) in kpis" :key="`kpi-${index}`">
										<td style="font-size: smaller; text-align: start;">{{ kpi.typeCompetenceName }}</td>
										<td style="font-size: smaller;">
											<p class="point-value">{{ kpi.totalWeighing | round }}%</p>
										</td>
									</tr>
									<tr>
										<td style="font-size: smaller; text-align: start; font-weight: bold;">Total Ponderado</td>
										<td style="font-size: smaller;">
											<p class="point-value">{{ totalKpi | round }}%</p>
										</td>
									</tr>
								</table>
							</div>
						</div>
						<div class="character">
							<button class="character-abbreviation">T</button>
							<p>Todos</p>
						</div>
					</div>
				</div>
				<div>
				</div>
			</section>
			<!-- Solo renderizar gráfico cuando hay datos cargados -->
			<div class="grafic-content tw-mt-6" v-if="!isLoading && dataGraphic.values && dataGraphic.values.length > 0">
				<graphic :data="dataGraphic" ref="graphicComponent" @drawn="captureCanvas" @drawn-error="onGraphicDrawError"></graphic>
			</div>
			<div class="leyend-graphic" v-if="!isLoading && typeCompetencies.length > 0">
				<div class="legend-item" v-for="(typeCompetence, index) in typeCompetencies" :key="index">
					<div class="legend-color" :style="`background-color: ${typeCompetence.color};`"></div>
					<p>{{ typeCompetence.nameCompetencie }}</p>
				</div>
			</div>
		</section>
		<section class="diagram-dispersion" v-if="!isLoading && flattenedTableData.length > 0">
			<p class="results">DIAGRAMA DE DISPERSIÓN</p>
			<div class="connt-info">
				<p>Esta página presenta la posición relativa a la puntuación promedio de las competencias para cada uno de los grupos de observadores. Se muestra cada competencia con su respectivo grupo.</p>
			</div>
			<div class="character-dispersion">
				<button class="character-abbreviation">T</button>
				<h4>Todos</h4>
			</div>
		</section>
		<section class="table-dispersion tw-my-10" v-if="!isLoading && flattenedTableData.length > 0">
			<table class="t-dispersion-title">
				<tr>
					<th style="width: 20%;"></th>
					<th style="width: 45%;"></th>
					<th v-for="(scale, index) in scales"
						:key="index"
						:style="`width: ${35 / scales.length}%;`">
						{{ scale.name }}
					</th>
				</tr>
			</table>
			<table class="t-dispersion">
				<tr v-for="(row, index) in flattenedTableData" :key="index">
					<th v-if="row.isFirstQuestion" :rowspan="row.rowspan" style="width: 20%;">
						{{ row.competenceName }}
					</th>
					<td style="width: 45%; text-align: start;">
						{{ row.questionName }}
					</td>
					<td v-for="(scaleQuestion, indexSQ) in row.scaleQuestions"
						:key="indexSQ"
						:style="`width: ${35 / scales.length}%;`">
						<button v-if="scaleQuestion.point" class="character-abbreviation">T</button>
					</td>
				</tr>
			</table>
		</section>
		<!-- Tabla de Indicadores -->
		<template v-if="!isLoading && detailedTableFiltered.length > 0">
			<section class="detailed-table-section tw-my-10">
				<p class="results">PLAN DE DESARROLLO</p>
				<div class="connt-info">
					<p>Esta sección detalla el sustento de indicadores de desempeño y
						las propuestas de mejora continua; un análisis basado en la ejecución
						de actividades, la profundización académica mediante la lectura y
						la perspectiva analítica del género cinematográfico como respaldo a
						las competencias.</p>
				</div>
			</section>
			<section class="table-dispersion tw-my-10">
				<table class="t-dispersion-title">
					<tr>
						<th style="width: 10%;">Competencia</th>
						<th style="width: 18%;">Pregunta</th>
						<th style="width: 24%;">Actividades</th>
						<th style="width: 24%;">Lecturas</th>
						<th style="width: 24%;">Género Cinematográfico</th>
					</tr>
				</table>
				<table class="t-dispersion">
					<tr v-for="(row, index) in detailedTableFiltered" :key="index">
						<th v-if="row.isFirstQuestion" :rowspan="row.rowspan" style="width: 10%;">
							{{ row.competenceName }}
						</th>
						<td style="width: 18%; text-align: start;">
							{{ row.questionName }}
						</td>
						<td v-if="row.isFirstQuestion" :rowspan="row.rowspan" style="width: 24%; text-align: start;">
							<table class="nested-table">
								<tr v-for="(indicator, indI) in (row.indicator && row.indicator.activity) || []" :key="`activity-${indI}`">
									<td>{{ indicator.text }}</td>
								</tr>
							</table>
						</td>
						<td v-if="row.isFirstQuestion" :rowspan="row.rowspan" style="width: 24%; text-align: start;">
							<table class="nested-table">
								<tr v-for="(indicator, indI) in (row.indicator && row.indicator.reading) || []" :key="`reading-${indI}`">
									<td>{{ indicator.text }}</td>
								</tr>
							</table>
						</td>
						<td v-if="row.isFirstQuestion" :rowspan="row.rowspan" style="width: 24%; text-align: start;">
							<table class="nested-table">
								<tr v-for="(indicator, indI) in (row.indicator && row.indicator.filmGenre) || []" :key="`film-${indI}`">
									<td>{{ indicator.text }}</td>
								</tr>
							</table>
						</td>
					</tr>
				</table>
			</section>
		</template>
		<btn-float buttonText="Subir" />
    </div>
</template>

<script>
import titleHeader from '@/components/diagnosis/title-header';
import downloadBtn from '@/components/diagnosis/download-btn';
import graphic from '@/components/shared/charts/graphic';
import btnFloat from '@/modules/evaluation-360/components/evaluation/btn-float';
import helper from '@/shared/helper';
import format from 'date-fns/format';
import { mapState } from 'vuex';
import { pathOr } from 'ramda';

const { generateBlob, showDownloadDialog, getLocalData } = helper;

function created() {
	this.loadData();
	this.startDate = format(this.process.startDate, 'DD/MM/YYYY');
	this.endDate = format(this.process.endDate, 'DD/MM/YYYY');
}
function mounted() {
	// this.loadData();
}

async function loadData() {
	this.isLoading = true;
	try {
		const pollIds = this.process.pollId;
		const params = {
			pollId: pollIds,
			employeeEvaluatedId: this.selectedEmployee.id,
		};
		const { data: response } = await this.$httpPraktiko.post(`process/report-detail/${this.process.id}`, params);
		this.competences = response.dispersion;
		this.roles = response.roles;
		this.roles = this.roles.map((r) => {
			const newR = { ...r };
			if (r.name === 'Cliente Interno') {
				newR.abbreviation = 'CI';
			} else if (r.name === 'Jefe') {
				newR.abbreviation = 'J';
			} else if (r.name === 'Par') {
				newR.abbreviation = 'P';
			} else if (r.name === 'Colaborador') {
				newR.abbreviation = 'C';
			}
			return newR;
		});
		this.scales = response.scales;
		// this.details = response.details;
		this.kpis = response.competenceSummary;
		this.totalKpi = response.totalWeighing;

		// Validar que graphicData exista y tenga datos
		if (response.graphicData && response.graphicData.length > 0) {
			const mergeArray = response.graphicData.reduce((result, obj) => ({
				...result,
				competencies: (result.competencies || []).concat(obj.competencies),
			}), {});
			mergeArray.values = mergeArray.competencies;
			delete mergeArray.competencies;
			this.typeCompetencies = mergeArray.values
				.filter((obj, index, array) => index === array
					.findIndex(item => item.nameCompetencie === obj.nameCompetencie),
				);
			mergeArray.values = mergeArray.values.map((f) => {
				const newF = { ...f };
				newF.v2 = f.avg;
				newF.v1 = 0;
				return newF;
			});
			const maxValueV = mergeArray.values.reduce((maxValue, currentValue) =>
				Math.max(maxValue, currentValue.v2), Number.NEGATIVE_INFINITY);
			mergeArray.maxValue = maxValueV + 1;
			mergeArray.greyZone = {
				max: maxValueV,
				min: 0,
			};
			this.dataGraphic = mergeArray;
		} else {
			// Si no hay datos, asignar un objeto vacío con la estructura correcta
			this.dataGraphic = {
				values: [],
				maxValue: 1,
				greyZone: {
					max: 0,
					min: 0,
				},
			};
			this.typeCompetencies = [];
			// Sin gráfico no hay canvas que capturar; la exportación seguirá el
			// camino de error existente en downloadReport/sendEmail.
			this.canvasDataUrl = null;
			this.isCanvasReady = false;
		}
	} catch (error) {
		console.error('[report-summary] loadData:', error);
		this.showGenericError();
	} finally {
		this.isLoading = false;
	}
}

function goToBack() {
	this.goTo('report-evaluation', { params: { id: this.process.id } });
}

async function downloadReport(type, contentType) {
	const pollIds = this.process.pollId;
	const body = {
		processId: this.process.id,
		pollId: pollIds,
		employeeEvaluatedId: this.selectedEmployee.id,
	};
	this.isDownloading = true;
	try {
		await new Promise(resolve => requestAnimationFrame(resolve));
		// Usar canvas cacheado si está disponible, sino capturar en el momento
		let myGraphs;
		if (this.isCanvasReady && this.canvasDataUrl) {
			myGraphs = this.canvasDataUrl;
		} else {
			const canvas = document.getElementById('canvas');
			if (canvas) {
				myGraphs = canvas.toDataURL();
			} else {
				throw new Error('Canvas no encontrado');
			}
		}
		const graphs = [myGraphs];
		body.base64 = graphs;
		const code = 'evaluation-360';
		const { data: pdfData } = await this.$httpPraktiko.post(`reports/${code}/evaluation/${type}`, body, { responseType: 'blob' });
		const blob = generateBlob(pdfData, contentType);
		showDownloadDialog(blob, 'evaluation-360', type);
	} catch (error) {
		console.error('[report-summary] downloadReport:', error);
		this.showGenericError(error && error.message === 'Canvas no encontrado'
			? 'No se encontró el gráfico del reporte para generar el PDF.'
			: undefined);
	} finally {
		this.isDownloading = false;
	}
}

async function sendEmail() {
	const pollIds = this.process.pollId;
	const body = {
		processId: this.process.id,
		pollId: pollIds,
		employeeEvaluatedId: this.selectedEmployee.id,
	};
	this.isDownloading = true;
	try {
		await new Promise(resolve => requestAnimationFrame(resolve));
		// Usar canvas cacheado si está disponible, sino capturar en el momento
		let myGraphs;
		if (this.isCanvasReady && this.canvasDataUrl) {
			myGraphs = this.canvasDataUrl;
		} else {
			const canvas = document.getElementById('canvas');
			if (canvas) {
				myGraphs = canvas.toDataURL();
			} else {
				throw new Error('Canvas no encontrado');
			}
		}
		const graphs = [myGraphs];
		body.base64 = graphs;
		const code = 'evaluation-360-pdf';
		await this.$httpPraktiko.post(`notifications/report-process/${code}`, body);
		this.showNotification('Correo enviado Correctamente');
	} catch (error) {
		console.error('[report-summary] sendEmail:', error);
		this.showGenericError(error && error.message === 'Canvas no encontrado'
			? 'No se encontró el gráfico del reporte para enviar por correo.'
			: undefined);
	} finally {
		this.isDownloading = false;
	}
}

function data() {
	return {
		startDate: null,
		endDate: null,
		competences: [],
		roles: [],
		scales: [],
		dataGraphic: {},
		typeCompetencies: [],
		kpis: [],
		totalKpi: 0,
		showSecondTable: true, // Control visibility of the second table
		secondScales: [], // Data for the second table
		isLoading: true, // Estado de carga inicial
		isDownloading: false, // Estado para descargas
		canvasDataUrl: null, // Cache del canvas capturado tras el evento 'drawn'
		isCanvasReady: false, // Indica si el gráfico ya fue dibujado y capturado
	};
}

// Captura el canvas cuando el componente graphic emite 'drawn': en ese
// momento el gráfico ya terminó de dibujarse, así que no hacen falta esperas
// fijas que dejaban carreras (PDF descargado con el gráfico en blanco).
function captureCanvas() {
	this.$nextTick(() => {
		try {
			const graphicEl = this.$refs.graphicComponent && this.$refs.graphicComponent.$el;
			const canvas = graphicEl && graphicEl.querySelector('canvas');
			if (canvas) {
				this.canvasDataUrl = canvas.toDataURL();
				this.isCanvasReady = true;
			}
		} catch (error) {
			// Silencioso: si falla, la exportación avisará al usuario.
			console.warn('No se pudo capturar el canvas automáticamente:', error);
		}
	});
}

function onGraphicDrawError(error) {
	console.error('[report-summary] graphic draw:', error);
	this.showGenericError('No se pudo generar el gráfico del reporte.');
}

export default {
	name: 'report-summary',
	data,
	created,
	mounted,
	components: {
		titleHeader,
		downloadBtn,
		graphic,
		btnFloat,
	},
	methods: {
		loadData,
		goToBack,
		downloadReport,
		sendEmail,
		captureCanvas,
		onGraphicDrawError,
	},
	computed: {
		...mapState('evaluation360', {
			process(state) {
				return pathOr(getLocalData('process'), ['process'], state.evaluation360) || [];
			},
			selectedEmployee(state) {
				return pathOr(getLocalData('selectedEmployee'), ['selectedEmployee'], state.evaluation360) || [];
			},
		}),
		hasChartData() {
			const values = this.dataGraphic && this.dataGraphic.values;
			return Boolean(values && values.length > 0);
		},
		// El PDF incrusta una captura del canvas, por lo que la exportación se
		// bloquea hasta que el gráfico esté dibujado y capturado. Si el proceso
		// no tiene gráfico (o su sección está oculta), la exportación sigue el
		// camino de error existente en vez de quedar bloqueada para siempre.
		canExportReport() {
			const chartShouldRender = this.hasChartData && this.scales.length > 0;
			return !this.isLoading && (!chartShouldRender || this.isCanvasReady);
		},
		flattenedTableData() {
			// Early return si no hay datos
			if (!this.competences || this.competences.length === 0) {
				return [];
			}
			const result = [];
			this.competences.forEach((competence) => {
				competence.questions.forEach((question, indexQ) => {
					result.push({
						competenceName: competence.competenceName,
						questionName: question.qustionName,
						scaleQuestions: question.scalesQuestion || question.scalesQuestion || [],
						isFirstQuestion: indexQ === 0,
						rowspan: competence.questions.length,
					});
				});
			});
			return result;
		},
		detailedTableFiltered() {
			// Early return si no hay datos
			if (!this.competences || this.competences.length === 0) {
				return [];
			}

			const result = [];

			// Procesar cada competencia
			this.competences.forEach((competence) => {
				// Filtrar preguntas que tienen escala con id 3 o 4
				const filteredQuestions = competence.questions.filter((question) => {
					const hasLowScaleId = question.scalesQuestion.some(sq =>
						(sq.point && (sq.id === 3 || sq.id === 4)) && competence.indicator);
					return hasLowScaleId;
				});

				// Solo procesar si hay preguntas filtradas
				if (filteredQuestions.length > 0) {
					// Usar los indicadores que vienen del backend
					const sharedIndicator = competence.indicator || {};

					// Crear una fila por cada pregunta, pero con indicadores compartidos
					filteredQuestions.forEach((question, index) => {
						result.push({
							competenceName: competence.competenceName,
							questionName: question.qustionName,
							indicator: sharedIndicator,
							isFirstQuestion: index === 0,
							rowspan: filteredQuestions.length,
						});
					});
				}
			});

			return result;
		},
	},
};
</script>

<style lang="scss" scoped>
.title-header {
	color: color(orange-dark);
	font-size: size(large);
	font-weight: bold;
	text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.date-header {
	color: color(gray-sidebar);
	font-size: size(large);
	font-weight: bold;
	text-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.methodology {
	width: 90%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 20px auto;
	border: 1px solid color(border-gray);
	background: linear-gradient(135deg, color(border-gray), rgba(color(border-gray), 0.8));
	border-radius: 20px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	
	.meth {
		color: color(green-light) !important;
		font-size: size(xlarge);
		font-weight: bold;
		padding: 15px;
		text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
	}
	.parraf {
		color: color(gray-tabs) !important;
		font-size: size(medium);
		padding: 15px;
		line-height: 1.5;
	}
}

.columns-competencies {
	width: 90%;
	display: grid;
	gap: 15px;
	align-items: stretch;
	justify-content: center;
	margin: 20px auto 50px;
	grid-template-columns: 1fr 1fr 1fr;

	.title-box {
		color: color(green-light);
		margin: 0 !important;
		padding: 0 !important;
		font-weight: 600;
		text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
	}

	.line {
		width: 40%;
		margin-bottom: 10px;
		border: 1px solid color(green-light);
		background: linear-gradient(90deg, transparent, color(green-light), transparent);
		height: 2px;
	}
	.box {
		width: 100%;
		height: 100%;
		background: linear-gradient(145deg, color(white), rgba(color(white), 0.95));
		border: 1px solid color(border-gray);
		border-radius: 12px;
		padding: 15px 25px 20px;
		color: color(gray-tabs) !important;
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);
		
		.table-evaluation {
			width: 100%;
			border: 1px solid color(border-gray);
			border-collapse: collapse;
			text-align: center;
			margin-top: 10px;
			
			th, td {
				border: 1px solid color(border-gray);
				padding: 8px 5px;
			}
			
			th {
				color: color(orange-dark);
				background-color: color(border-gray);
				font-weight: bold;
			}
		}
		
		ol, ul {
			padding-left: 20px;
			margin: 10px 0 0 0;
			
			li {
				margin-bottom: 8px;
				line-height: 1.4;
			}
		}
	}
}

.global-results-columns {
	grid-template-columns: 1fr 1fr;
	justify-items: center; // Añade esta línea
	align-items: flex-start;

	div {
		display: flex;
		flex-direction: column;
		width: 100%; // Asegura que los divs ocupen todo el ancho disponible
	}

	.box {
		flex: 1;
		display: flex;
		flex-direction: column;
	}
}

// Nueva clase específica para la sección de resultados globales
.results-tables-container {
	width: 90%;
	display: grid;
	gap: 15px;
	align-items: flex-start;
	justify-content: center;
	margin: auto;
	// Por defecto: 1 columna centrada cuando NO hay KPIs
	grid-template-columns: 1fr;
	max-width: 800px;

	.title-box {
		color: color(green-light);
		margin: 0 !important;
		padding: 0 !important;
	}

	.line {
		width: 40%;
		margin-bottom: 10px;
		border: 1px solid color(green-light);
	}

	.box {
		width: 100%;
		height: auto;
		min-height: 200px;
		background-color: color(white);
		border: 1px solid color(border-gray);
		border-radius: 10px;
		padding: 20px 25px;
		color: color(gray-tabs) !important;
	}
}

// Cuando SÍ hay KPIs: 1 columna para tabla fusionada
 .results-tables-container.has-kpis {
	grid-template-columns: 1fr;
	max-width: 100%;
	justify-items: center;

	> div {
		display: flex;
		flex-direction: column;
		width: 100%;
		max-width: 800px; // Limitar ancho para legibilidad
	}

	.box {
		flex: 1;
		display: flex;
		flex-direction: column;
	}
}

.global-results, .diagram-dispersion, .detailed-table-section {
	width: 90%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin: 20px auto;
	.results {
		color: color(orange-dark);
		font-size: size(xlarge);
		font-weight: bold;
		text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		margin-bottom: 15px;
	}
	.connt-info {
		width: 80%;
		border: 1px solid color(border-gray);
		background: linear-gradient(145deg, color(white), rgba(color(white), 0.95));
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		margin: 20px auto;
		padding: 20px 25px;
		color: color(gray-tabs) !important;
		border-radius: 20px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
		line-height: 1.5;
	}
}

.table-evaluation {
	width: 100%;
	border: 1px solid color(border-gray);
	border-collapse: collapse;
	text-align: center;
	min-height: 180px;
	border-radius: 10px;
	overflow: hidden;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	
	tr {
		th, td {
			border: 1px solid color(border-gray);
			padding: 10px 8px;
		}
		th {
			color: color(orange-dark);
			background: linear-gradient(135deg, color(border-gray), rgba(color(border-gray), 0.8));
			font-weight: bold;
			text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
		}
		tr:nth-child(even) {
			background-color: rgba(0, 0, 0, 0.02);
		}
	}
}
.tables-container {
	display: flex;
	gap: 20px;
	align-items: stretch;
	justify-content: center;
	
	&.has-kpis {
		justify-content: space-between;
		.table-section {
			flex: 1;
			max-width: 48%;
		}
	}
	
	&:not(.has-kpis) {
		justify-content: center;
		.table-section {
			flex: 1;
			max-width: 100%;
		}
	}
}
.table-subtitle {
	color: color(green-light);
	font-size: size(medium);
	font-weight: bold;
	margin: 0 0 10px 0;
	text-align: center;
}
.character {
	width: 100%;
	display: flex;
	gap: 10px;
	padding: 10px 0;
}
.character-abbreviation {
	border-radius: 50px;
	border: none;
	width: 22px;
	height: 22px;
	color: color(white);
	font-weight: bold;
	text-align: center;
	background: linear-gradient(135deg, color(green-light), rgba(color(green-light), 0.8));
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
	cursor: pointer;
}
.point-value {
	color: color(green-light);
	font-size: size(xsmall);
	padding: 0;
	margin: 0;
	font-weight: bold;
}
.scale-entry {
	display: flex;
	align-items: center;
	gap: 8px;
}
.scale-badge {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;
	border-radius: 50%;
	background: linear-gradient(135deg, color(orange-dark), color(orange-light));
	color: white;
	font-weight: bold;
	font-size: size(small);
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
	border: 2px solid color(white);
}
.scale-label {
	color: color(gray-tabs);
	font-size: size(small);
	font-weight: 500;
}
.score-display {
	display: flex;
	align-items: center;
	gap: 5px;
	justify-content: center;
}
.score-badge {
	background-color: color(green-light);
	color: white;
	padding: 3px 8px;
	border-radius: 12px;
	font-weight: bold;
	font-size: size(xsmall);
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.percentage-badge {
	display: inline-block;
	padding: 4px 8px;
	border-radius: 16px;
	background: linear-gradient(135deg, color(green-light), color(green-dark));
	color: white;
	font-weight: bold;
	font-size: size(xsmall);
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
	border: 1px solid color(white);
}
.percentage-badge.total-badge {
	background: linear-gradient(135deg, color(orange-dark), color(orange-light));
	font-size: size(small);
	padding: 6px 12px;
}

.character-dispersion {
	width: 100%;
	display: flex;
	justify-content: start;
	align-items: center;
	gap: 10px;
	padding: 12px 35px;
	color: color(gray-tabs) !important;
	background: linear-gradient(135deg, color(border-gray), rgba(color(border-gray), 0.9)) !important;
	border-radius: 8px;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
.t-dispersion-title {
	width: 100%;
	border: 1px solid color(border-gray);
	border-collapse: collapse;
	text-align: center;
	margin: 0;
	table-layout: fixed;
	border-radius: 10px;
	overflow: hidden;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	
	tr {
		th, td {
			border: 1px solid color(border-gray);
			padding: 8px 5px;
			color: color(gray-tabs);
			background: linear-gradient(135deg, color(border-gray), rgba(color(border-gray), 0.8));
			font-weight: 600;
			text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
		}
	}
}

.t-dispersion {
	width: 100%;
	border: 1px solid color(border-gray);
	border-collapse: collapse;
	text-align: center;
	margin: 0;
	table-layout: fixed;
	border-radius: 10px;
	overflow: hidden;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	transition: box-shadow 0.3s ease;
	
	&:hover {
		box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
	}
	
	tr {
		th, td {
			border: 1px solid color(border-gray);
			padding: 8px 5px;
			color: color(gray-tabs);
			vertical-align: middle;
			transition: background-color 0.2s ease;
		}
		
		th {
			background: linear-gradient(135deg, rgba(color(green-light), 0.1), rgba(color(green-light), 0.05));
			font-weight: 600;
		}
		
		&:hover td {
			background-color: rgba(color(green-light), 0.05);
		}
	}
}

.nested-table {
	width: 100%;
	border: none;
	border-collapse: collapse;
	margin: 0;
	padding: 0;
	table-layout: fixed;

	tr {
		td {
			border: none;
			padding: 4px 0;
			color: color(gray-tabs);
			font-size: size(small);
			line-height: 1.4;
			text-align: start;
			word-wrap: break-word;
			overflow-wrap: break-word;
			hyphens: auto;
			max-width: 100%;
		}
	}
}

.grafic-content {
	padding: 30px;
	border: 1px solid color(border-gray);
	border-radius: 12px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
	background: color(white);
	position: relative;
	overflow: hidden;
	
	&::after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: radial-gradient(circle at top right, rgba(color(green-light), 0.03), transparent 70%);
		pointer-events: none;
	}
}

.leyend-graphic {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	width: 85%;
	max-width: 800px;
	margin: 25px auto 0;
	gap: 20px;
	padding: 25px;
	background: linear-gradient(145deg, color(white), rgba(color(white), 0.98));
	border: 1px solid rgba(color(border-gray), 0.8);
	border-radius: 16px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
	position: relative;
	
	.legend-item {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 12px 20px;
		border-radius: 50px;
		background: linear-gradient(145deg, rgba(color(white), 0.9), color(white));
		border: 1px solid rgba(0, 0, 0, 0.04);
		box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
		position: relative;
		z-index: 1;
		
		.legend-color {
			width: 18px;
			height: 18px;
			border-radius: 50%;
			box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
			border: 2px solid color(white);
			position: relative;
			
			&::after {
				content: '';
				position: absolute;
				top: -2px;
				left: -2px;
				right: -2px;
				bottom: -2px;
				border-radius: 50%;
				background: inherit;
				opacity: 0.2;
				z-index: -1;
			}
		}
		
		p {
			margin: 0;
			font-size: 13px;
			font-weight: 500;
			color: color(gray-tabs);
			letter-spacing: 0.2px;
		}
	}
}

// Loading overlay
.report-summary-wrapper {
	position: relative;
	min-height: 100vh;
}

.loading-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(255, 255, 255, 0.85);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
	backdrop-filter: blur(2px);
}
</style>


// WEBPACK FOOTER //
// src/modules/evaluation-360/components/evaluation/report-summary.vue